export default [
  {
    path: "/mine",
    name: "Mine",
    component: () => import("@/views/Mine/Mine"),
    meta: { title: "我的" },
  },
  {
    path: "/safety",
    name: "safety",
    component: () => import("@/views/Mine/safety"),
    meta: { title: "安全中心" },
  },
  {
    path: "/identityVerification",
    name: "identityVerification",
    component: () => import("@/views/Mine/identityVerification"),
    meta: { title: "身份验证" },
  },
  {
    path: "/identityVerificationUpload",
    name: "identityVerificationUpload",
    component: () => import("@/views/Mine/identityVerificationUpload"),
    meta: { title: "身份上传" },
  },
  {
    path: "/regionSelect",
    name: "regionSelect",
    component: () => import("@/views/Mine/regionSelect"),
    meta: { title: "地区选择", keepAlive: true },
  },
  {
    path: "/modifyAsset",
    name: "modifyAsset",
    component: () => import("@/views/Mine/modifyAssetPassword"),
    meta: { title: "修改资产密码" },
  },
  {
    path: "/modifyLogin",
    name: "modifyLoginPassword",
    component: () => import("@/views/Mine/modifyLoginPassword"),
    meta: { title: "修改登录密码" },
  },
  {
    path: "/invite",
    name: "Invite",
    component: () => import("@/views/Mine/Invite"),
    meta: { title: "邀请好友" },
  },
  {
    path: "/inviteFriend",
    name: "InviteFriend",
    component: () => import("@/views/Mine/InviteFriend"),
    meta: { title: "好友详情" },
  },
  {
    path: "/inviteRule",
    name: "InviteRule",
    component: () => import("@/views/Mine/InviteRule"),
    meta: { title: "邀请规则" },
  },
  {
    path: "/setLanguage",
    name: "SetLanguage",
    component: () => import("@/views/Mine/SetLanguage"),
    meta: { title: "选择语言" },
  },
  {
    path: "/notice",
    name: "notice",
    component: () => import("@/views/Mine/notice"),
    meta: { title: "通知中心" },
  },
  {
    path: "/noticeDetail",
    name: "noticeDetail",
    component: () => import("@/views/Mine/noticeDetail"),
    meta: { title: "通知中心" },
  },
  {
    path: "/message",
    name: "Message",
    component: () => import("@/views/Mine/Message"),
    meta: { title: "消息" },
  },
  {
    path: "/contactUs",
    name: "ContactUs",
    component: () => import("@/views/Mine/ContactUs"),
    meta: { title: "联系我们" },
  },
  {
    path: "/help",
    name: "Help",
    component: () => import("@/views/Mine/Help"),
    meta: { title: "帮助与反馈" },
  },
  {
    path: "/address",
    name: "Address",
    component: () => import("@/views/Mine/Address"),
    meta: { title: "我的地址" },
  },
  {
    path: "/addressDetail",
    name: "AddressDetail",
    component: () => import("@/views/Mine/AddressDetail"),
    meta: { title: "我的地址" },
  },
  {
    path: "/bannerDetail",
    name: "BannerDetail",
    component: () => import("@/views/Mine/BannerDetail"),
    meta: { title: "详情" },
  },
  {
    path: "/academy",
    name: "academy",
    component: () => import("@/views/Mine/academy"),
    meta: { title: "成长学院" },
  },
  {
    path: "/academyInfo",
    name: "academyInfo",
    component: () => import("@/views/Mine/academyInfo"),
    meta: { title: "详情" },
  },

  {
    path: "/moreFeatures",
    name: "moreFeatures",
    component: () => import("@/views/Mine/moreFeatures"),
    meta: { title: "更多功能" },
  },
  {
    path: "/downloadApp",
    name: "downloadApp",
    component: () => import("@/views/Mine/downloadApp"),
    meta: { title: "下载APP" },
  },
  {
    path: "/downloadAppUrl",
    name: "downloadAppUrl",
    component: () => import("@/views/Mine/downloadAppUrl"),
    meta: { title: "下载APP" },
  },
  {
    path: "/myMessage",
    name: "myMessage",
    component: () => import("@/views/Mine/myMessage"),
    meta: { title: "我的通知" },
  },
  {
    path: "/desc",
    name: "desc",
    component: () => import("@/views/Mine/desc"),
    meta: { title: "简介" },
  },
  {
    path: "/vipRule",
    name: "vipRule",
    component: () => import("@/views/Mine/vipRule"),
    meta: { title: "vip" },
  },
];



// WEBPACK FOOTER //
// ./src/router/config/MineRouter.js